var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailureSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C14.6047 0 0.5 14.1047 0.5 31.5C0.5 48.8953 14.6047 63 32 63C49.3953 63 63.5 48.8953 63.5 31.5C63.5 14.1047 49.3953 0 32 0ZM43.6297 43.4672L38.9891 43.4461L32 35.1141L25.018 43.4391L20.3703 43.4602C20.0609 43.4602 19.8078 43.2141 19.8078 42.8977C19.8078 42.7641 19.857 42.6375 19.9414 42.532L29.0891 31.6336L19.9414 20.7422C19.8564 20.6391 19.8093 20.5101 19.8078 20.3766C19.8078 20.0672 20.0609 19.8141 20.3703 19.8141L25.018 19.8352L32 28.1672L38.982 19.8422L43.6227 19.8211C43.932 19.8211 44.1852 20.0672 44.1852 20.3836C44.1852 20.5172 44.1359 20.6438 44.0516 20.7492L34.918 31.6406L44.0586 42.5391C44.143 42.6445 44.1922 42.7711 44.1922 42.9047C44.1922 43.2141 43.9391 43.4672 43.6297 43.4672Z",
    fill: "#F5222D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureSignal);
export default __webpack_public_path__ + "static/media/failureSignal.a73b820d.svg";
export { ForwardRef as ReactComponent };